var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SalesforceService, SalesforceMockService } from 'hx-salesforce';
import { checkEnv } from 'hx-util';
import { isUserDetails } from '@/components/user-details/helpers/is-user-details.helper';
import { globalLeadSource } from 'hx-analytics/src/functions/url-lead-source/get-url-lead-source.helper';
import { getAttributtionFromStore } from '@/helpers/get-attribution-from-store.helper';
var SalesforceServiceFacade = /** @class */ (function () {
    function SalesforceServiceFacade() {
        if (checkEnv([
            'REACT_APP_SALESFORCE_LEADS_SOURCE_PREFIX',
            'REACT_APP_SALESFORCE_API_URL',
            'REACT_APP_SALESFORCE_API_KEY',
        ])) {
            this._service = new SalesforceService();
        }
        else {
            this._service = new SalesforceMockService();
        }
    }
    SalesforceServiceFacade.prototype.sendTestCompleted = function (_a) {
        var wizard = _a.wizard, widget = _a.widget, dinTest = _a.dinTest;
        return __awaiter(this, void 0, Promise, function () {
            var userDetails, test;
            return __generator(this, function (_b) {
                if (!isUserDetails(widget.userDetails)) {
                    console.error("userDetails type error: ".concat(widget.userDetails));
                    return [2 /*return*/];
                }
                userDetails = widget.userDetails;
                test = __assign({ first_name: userDetails['first-name'], last_name: userDetails['last-name'], email: userDetails['email'], contact_number: "+1".concat(userDetails['contact-number']), snr_result: Number(dinTest.result.averageSnr), hearing_category: dinTest.result.category, user_selected_volume: Number(wizard.form.volume), source: globalLeadSource ||
                        "".concat(process.env.REACT_APP_SALESFORCE_LEADS_SOURCE_PREFIX), consent: userDetails['consent'], newsletter_consent: userDetails['consent'] }, getAttributtionFromStore(widget.hostDetails));
                return [2 /*return*/, this._service.sendTestCompleted(test)];
            });
        });
    };
    SalesforceServiceFacade.prototype.sendVideoCallCompleted = function (_a) {
        var speakToAnExpertForm = _a.speakToAnExpertForm;
        return __awaiter(this, void 0, Promise, function () {
            var preferredContactMethodString, test;
            return __generator(this, function (_b) {
                preferredContactMethodString = Object.entries(speakToAnExpertForm['preferred-contact-method'])
                    .filter(function (_a) {
                    var key = _a[0], value = _a[1];
                    return value;
                })
                    .map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return key;
                })
                    .join(', ');
                test = {
                    first_name: speakToAnExpertForm['first-name'],
                    last_name: speakToAnExpertForm['last-name'],
                    email: speakToAnExpertForm['email'],
                    contact_number: speakToAnExpertForm['contact-number'],
                    preferred_contact_method: preferredContactMethodString,
                    source: "".concat(process.env.REACT_APP_SALESFORCE_LEADS_SOURCE_PREFIX, "F2"),
                };
                return [2 /*return*/, this._service.sendVideoCallCompleted(test)];
            });
        });
    };
    SalesforceServiceFacade.prototype.sendCallbackRequested = function (_a) {
        var speakToAnExpertForm = _a.speakToAnExpertForm;
        return __awaiter(this, void 0, Promise, function () {
            var preferredContactMethodString, test;
            return __generator(this, function (_b) {
                preferredContactMethodString = Object.entries(speakToAnExpertForm['preferred-contact-method'])
                    .filter(function (_a) {
                    var key = _a[0], value = _a[1];
                    return value;
                })
                    .map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return key;
                })
                    .join(', ');
                test = {
                    first_name: speakToAnExpertForm['first-name'],
                    last_name: speakToAnExpertForm['last-name'],
                    email: speakToAnExpertForm['email'],
                    contact_number: speakToAnExpertForm['contact-number'],
                    preferred_contact_method: preferredContactMethodString,
                    callback_requested: true,
                    source: "".concat(process.env.REACT_APP_SALESFORCE_LEADS_SOURCE_PREFIX, "F2"),
                };
                return [2 /*return*/, this._service.sendCallbackRequested(test)];
            });
        });
    };
    return SalesforceServiceFacade;
}());
export { SalesforceServiceFacade };
